import type { ConversionProgress, ConversionResult, ConverterCapabilities, EngineError } from './types';

/** Worker RPC 协议版本，主线程与 Worker 不一致时直接拒绝执行。 */
export const WORKER_PROTOCOL_VERSION = 1;

export interface ConvertRequestPayload {
  converterId: string;
  targetFormat: string;
  fileName: string;
  mime: string;
  /** 源文件字节，主线程以 Transferable 方式移交，避免大文件复制。 */
  buffer: ArrayBuffer;
  options?: Record<string, unknown>;
}

export interface ConvertTaskRequest {
  id: string;
  version: number;
  type: 'convert';
  payload: ConvertRequestPayload;
}

export interface CancelTaskRequest {
  id: string;
  version: number;
  type: 'cancel';
}

/** 能力查询：AVIF WASM 等运行时能力只能由 Worker 侧探测。 */
export interface CapabilitiesRequest {
  id: string;
  version: number;
  type: 'capabilities';
}

export type WorkerRequest = ConvertTaskRequest | CancelTaskRequest | CapabilitiesRequest;

export interface ProgressMessage {
  id: string;
  type: 'progress';
  progress: ConversionProgress;
}

export interface DoneMessage {
  id: string;
  type: 'done';
  ok: boolean;
  result?: ConversionResult;
  error?: EngineError;
}

export interface CapabilitiesMessage {
  id: string;
  type: 'capabilities';
  capabilities: ConverterCapabilities[];
}

export type WorkerResponse = ProgressMessage | DoneMessage | CapabilitiesMessage;

export function isWorkerResponse(value: unknown): value is WorkerResponse {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as { id?: unknown; type?: unknown };
  if (typeof candidate.id !== 'string') return false;
  return candidate.type === 'progress' || candidate.type === 'done' || candidate.type === 'capabilities';
}
